import UserNotificationApi from "@/api/UserNotificationApi";
import { useUser } from "./useUser";
import { hideLoading, showLoading } from "@/helpers/loadingHelper";
import { showAlert } from "@/helpers/alertHelper";
import { UserNotificationConfig } from "@/models/UserNotificationConfig";
import { useNotificationStore } from "@/stores/store.notification";
import { addListeners, registerNotifications, getDeliveredNotifications, createNotificationChannel, listChannels } from '@/helpers/notification';
import { storeToRefs } from "pinia";
import { useIonRouter } from "@ionic/vue";


export const  useNotificacion = () => {
    const notificationStore = useNotificationStore();
    const { notifications,config } = storeToRefs(notificationStore);
    const { userData, isMobile } = useUser();
    const ionRouter = useIonRouter();

    const initNotificationConfig = async () => {
        if(isMobile.value){
            await createNotificationChannel(); // First create channel
            await addListeners(userData.value.id, ionRouter);
            await registerNotifications(); // Then register
    
            setTimeout(async () => {
                await getDeliveredNotifications();
                await listChannels(); // Verify channel appears in list
            }
            , 1000);
        }
    }

    const list = async () => {
        showLoading('Cargando notificaciones...');
        try{
            const notiList =  await UserNotificationApi.list(userData.value.id);
            notifications.value = notiList.data;
            hideLoading();
        }catch(e:any){
            hideLoading();
            showAlert('Error!', 'Disculpe, no se han podido cargar las notificaciones');
            console.log(e);
        }
    }

    const getConfig = async () => {
       
       showLoading('Cargando configuracion...');
       try{
            config.value = await UserNotificationApi.listConfig(userData.value.id);
            console.log(config.value);
            hideLoading();
       }catch(e:any){
           hideLoading();
           showAlert('Error!', 'Disculpe, no se han podido cargar la configuracion de  notificaciones');
           console.log(e);
       }
    }

    const updateConfig = async (data:UserNotificationConfig) => {
        showLoading('Guardando configuracion...');
        try{
            await UserNotificationApi.updateNotificationConfig(data);
            hideLoading();
            getConfig();
        }catch(e:any){
            hideLoading();
            showAlert('Error!', 'Disculpe, no se han podido guardar la configuracion de  notificaciones');
            console.log(e);
        }
            
    }
    
    return {
        initNotificationConfig,
        list,
        getConfig,
        updateConfig,
        notifications,
        config
    }
}